module.exports = __webpack_public_path__ + "static/img/l_cymnsxg.93049ade.png";